const incoterms = [
  'REVOOLOOP',
  'DDP',
  'FOB'
]

export default incoterms